import { render } from "./secondstepGrooming.vue?vue&type=template&id=b0f279ee&scoped=true"
import script from "./secondstepGrooming.vue?vue&type=script&lang=js"
export * from "./secondstepGrooming.vue?vue&type=script&lang=js"

import "./secondstepGrooming.vue?vue&type=style&index=0&id=b0f279ee&scoped=true&lang=css"

import exportComponent from "E:\\coding\\pharaoh_frog_barber\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0f279ee"]])

export default __exports__